const VUE_APP_API_COUPON_URL = document.querySelector("html").getAttribute("api_coupon_url");

export default VUE_APP_API_COUPON_URL